<template>
  <modal
    name="bank-movements-waiting-modal"
    height="auto"
    adaptive
  >
    <div class="flex flex-col items-center py-10 justify-items-center">
      <div class="flex flex-col items-center h-40 justify-items-center">
        <div class="flex">
          <inline-svg
            :src="require('@assets/images/gear.svg')"
            class="w-20 mr-2 opacity-90 text-sc-blue animate-spin"
            :style="{ animation: 'spin 4s linear infinite'}"
          />
          <inline-svg
            :src="require('@assets/images/gear.svg')"
            class="w-20 ml-2 opacity-90 text-sc-blue animate-spin"
            :style="{ animation: 'spin 4s linear infinite'}"
          />
        </div>
        <inline-svg
          :src="require('@assets/images/gear.svg')"
          class="w-20 opacity-90 text-sc-blue animate-spin"
          :style="{ animation: 'spin 4s linear infinite'}"
        />
      </div>
      <p class="pt-2 text-lg w-80 text-primary">
        {{ waitingInstitutionsMessage }}
      </p>

      <div class="flex flex-col text-left">
        <p class="pt-2 text-menu">
          Esto puede tardar alrededor de 10 minutos.
        </p>
        <p class="pt-2 text-menu ">
          {{ emailMessage }}
        </p>
      </div>
      <button
        class="px-4 py-2 mt-8 text-sm leading-5 text-center text-white rounded bg-sc-blue"
        @click="hide()"
      >
        {{ $t('message.table.waitingModal.okButton') }}
      </button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    institutions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    institutionsLength() {
      return this.institutions.length;
    },
    plural() {
      return this.institutionsLength > 1;
    },
    mode() {
      if (this.plural) return 'plural';

      return 'singular';
    },
    emailMessage() {
      return this.$t(`message.table.waitingModal.sendEmail.${this.mode}`);
    },
    waitingInstitutionsMessage() {
      const start = this.$t('message.table.waitingModal.waitingMessageStart');
      const join = this.plural ? this.$t('message.table.waitingModal.waitingMessageAnd') : '';
      const lastInstitution = this.institutions[this.institutionsLength - 1];
      const otherInstitutions = this.institutions.slice(0, this.institutionsLength - 1).join(', ');
      const end = this.$t(`message.table.waitingModal.waitingMessageEnd.${this.mode}`);

      return `${start} ${otherInstitutions} ${join} ${lastInstitution} ${end}`;
    },
  },
  mounted() {
    this.show();
  },
  methods: {
    show() {
      this.$modal.show('bank-movements-waiting-modal');
    },
    hide() {
      this.$modal.hide('bank-movements-waiting-modal');
    },
  },
};
</script>
